import { Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const ActionCell = ({ row, table }) => {
  const meta = table.options.meta;

  const remove = (e) => {
    meta?.deleteEvent(row.original.id);
  };

  return (
    <div className="d-flex gap-1">
      <Button
        className="edit-cell-action-button"
        onClick={remove}
        variant="danger"
        size="sm"
      >
        <FontAwesomeIcon icon={["fas", "trash"]} size="sm" />
      </Button>
    </div>
  );
};

export default ActionCell;
